import {
  ItemlookupAction,
  ItemlookupActionTypes,
  ItemlookupState
} from '../../types/itemlookup';

const initialState: ItemlookupState = {
  items: [],
  itemBins: [],
  message: '',
  loading: false,
  loadingBins: false
};

export const itemlookupReducer = (
  state = initialState,
  action: ItemlookupAction
): ItemlookupState => {
  switch (action.type) {
    case ItemlookupActionTypes.GET_NS_ITEM:
      return {
        ...state,
        items: action.payload,
        message: !action.payload?.length ? 'No items found' : '',
        loading: false
      };
    case ItemlookupActionTypes.GET_NS_ITEM_BINS:
      return {
        ...state,
        itemBins: action.payload,
        loadingBins: false
      };
    case ItemlookupActionTypes.SET_NS_ITEM_LOADING:
      return {
        ...state,
        loading: true
      };
    case ItemlookupActionTypes.SET_NS_ITEM_BINS_LOADING:
      return {
        ...state,
        loadingBins: true
      };
    case ItemlookupActionTypes.CLEAR_ITEMLOOKUP:
      return initialState;
    default:
      return state;
  }
};
